import { Component } from 'react';
import Loading from '../../../components/Loading';
import Message from '../../Message';
import DomainImage from '../../../components/DomainImage';
import { withTranslation } from 'react-i18next';

class ActivateAccountDomains extends Component {
    constructor(props) {
        super();
        this.onSubmit = this.onSubmit.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.onChange = this.onChange.bind(this);

        this.domains = JSON.parse(props.domains);
        this.all_existing_urls = JSON.parse(props.all_existing_urls);
        this.allExistingDomains = this.domains.filter(
            (item) => !this.all_existing_urls.includes(item.siteUrl),
        );

        console.log('this.domains', this.domains);

        this.state = {
            domains: [],
            loading: false,
            errors: {},
        };
    }

    onChange(domain) {
        const domains = this.state.domains;
        const newDomains = domains.includes(domain)
            ? domains.filter((item) => item !== domain)
            : [...domains, domain];
        this.setState({
            domains: newDomains,
        });
    }

    onSubmit() {
        if (this.state.domains.length === 0) return;
        this.setState({
            loading: true,
        });
        const a = document.createElement('a');
        a.href = `/domains/link?account=${
            this.props.account_pk
        }&domains_url=${this.state.domains.join(',')}`;
        a.click();
    }

    selectAll() {
        if (this.allExistingDomains.length === this.state.domains.length) {
            this.setState({
                domains: [],
            });
        } else {
            this.setState({
                domains: this.allExistingDomains.map((item) => item.siteUrl),
            });
        }
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="settings-add-user">
                    <div className="card p-20">
                        <button className="back-btn" onClick={() => window.history.back()}>
                            <i className="icon-arrow-left" />
                        </button>
                        <div className="customers-selects-header">
                            {t('settings.manage_account.select_domains')}
                        </div>
                        <div className="customers-selects-header-sub">
                            {t('settings.manage_account.select_domains_subheader')}
                        </div>
                        {this.state.errors['domains'] && (
                            <div className="error-message">
                                {t('settings.manage_account.please_select_domain')}
                            </div>
                        )}
                        {this.domains?.length ? (
                            <div className="customers-selects">
                                <div className="customers-selects-item">
                                    <div className="d-flex align-items-center">
                                        <input
                                            id="domain-all"
                                            type="checkbox"
                                            onChange={this.selectAll}
                                            checked={this.state.allSelect}
                                        />
                                        <label htmlFor="domain-all">
                                            <span>{t('settings.manage_account.select_all')}</span>
                                        </label>
                                    </div>
                                </div>
                                {this.domains?.map((item) => (
                                    <div
                                        key={item.siteUrl}
                                        className="customers-selects-item"
                                        style={{
                                            opacity: this.all_existing_urls.includes(item.siteUrl)
                                                ? 0.3
                                                : 1,
                                        }}
                                    >
                                        <div className="d-flex align-items-center">
                                            <input
                                                id={`domain-${item?.siteUrl}`}
                                                type="checkbox"
                                                onChange={() => this.onChange(item?.siteUrl)}
                                                checked={
                                                    this.state.domains.includes(item?.siteUrl) ||
                                                    this.all_existing_urls.includes(item.siteUrl)
                                                }
                                                disabled={this.all_existing_urls.includes(
                                                    item.siteUrl,
                                                )}
                                            />
                                            <label htmlFor={`domain-${item?.siteUrl}`}>
                                                <div className="customers-selects-item-img">
                                                    <DomainImage domain_name={item.name} />
                                                </div>
                                                <span>{item?.name}</span>{' '}
                                            </label>
                                        </div>
                                        <span className="customers-selects-item-permission">
                                            {item?.permissionLevel}
                                        </span>
                                    </div>
                                ))}
                                <div className="customers-selects-item d-flex justify-content-end">
                                    <button
                                        className="onboarding-btn-next"
                                        onClick={this.onSubmit}
                                        disabled={
                                            this.state.loading || this.state.domains.length === 0
                                        }
                                    >
                                        {t('settings.manage_account.add_domains')}
                                        {this.state.loading && <Loading onlyPreloader />}
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className="mt-16">
                                {t('settings.manage_account.account_message')}
                            </div>
                        )}
                    </div>
                </div>
                {this.state.message && (
                    <div className="messages">
                        <Message
                            message_tags={this.state.message_tags}
                            message={this.state.message}
                            deleteMessage={this.deleteMessage}
                        />
                    </div>
                )}
            </>
        );
    }
}

export default withTranslation()(ActivateAccountDomains);
